import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

import { useHeaderSlot } from '../../AppShell/HeaderSlotContext';
import { useShell } from '../../AppShell/ShellContext';

export interface FullbleedVariantProps {
  children: React.ReactNode;
}

/**
 * Fullbleed page variant — no gutters or extra spacing, but still accounts
 * for the fixed-position sidebar on desktop (md+).
 * Used by Messaging, Inbox, and other full-width pages.
 *
 * The header slot is set to `null` by PageShell when this variant is active,
 * which hides the AppBar content in AppShell.
 */
export const FullbleedVariant: React.FC<FullbleedVariantProps> = ({
  children,
}) => {
  const { drawerWidth, isResizableSidebarActive } = useShell();
  const { showSidebar } = useHeaderSlot();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const paddingLeft =
    isMdUp && showSidebar && !isResizableSidebarActive ? drawerWidth : 0;

  return (
    <div
      className="flex h-full flex-1 flex-col overflow-auto"
      style={{ paddingLeft }}
    >
      {children}
    </div>
  );
};
